import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	classicPageHeaderOld: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'portal-settings.portal-settings-header.classic-page-header',
		defaultMessage: 'Portal settings',
		description: 'The title of the the service project settings page for portal settings',
	},
	classicPageHeader: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'portal-settings.portal-header.classic-page-header',
		defaultMessage: 'Portal',
		description: 'The title of the the service project settings page for portal settings',
	},
	pageTitle: {
		id: 'portal-settings.portal-settings-header.page-title',
		defaultMessage: 'Project settings',
		description:
			'Header on the service project settings page below the breadcrumbs indicating the current navigation.',
	},
});
